import { useMutation } from 'react-query';
import {
  ReportCustomersParams,
  ReportModalEmployeeParams,
  ReportSuppliersParams,
} from './Report.types';
import {
  generateCustomerCsvData,
  generateCustomersReport,
  generateCustomersTags,
  generateCustomerVehiclesReport,
  generateEmployeesReport,
  generateInsurerDataReport,
  generateSuppliersReport,
} from './Report.service';
import { useServiceError } from '@/hooks';
import notificationError from '@/utils/functions/notificationError';

// People
export function useGenerateSupplierReport() {
  const mutation = useMutation((obj: ReportSuppliersParams) =>
    generateSuppliersReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useGenerateCustomerVehiclesReport() {
  return useMutation(generateCustomerVehiclesReport, {
    onError(error) {
      notificationError(error);
    },
  });
}

export function useGenerateCustomersReport() {
  const mutation = useMutation((obj: ReportCustomersParams) =>
    generateCustomersReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useCustomerReportCsvGenerate() {
  const mutation = useMutation(generateCustomerCsvData);

  useServiceError(mutation.error);

  return mutation;
}

export function useGenerateCustomersTags() {
  const mutation = useMutation(generateCustomersTags);

  useServiceError(mutation.error);

  return mutation;
}

export function useGenerateEmployeeReport() {
  const mutation = useMutation((obj: ReportModalEmployeeParams) =>
    generateEmployeesReport(obj),
  );

  useServiceError(mutation.error);

  return mutation;
}

export function useInsurerDataReport() {
  const mutation = useMutation(generateInsurerDataReport);

  useServiceError(mutation.error);

  return mutation;
}
